import React from 'react';
import { aboutService } from '../../services/aboutService';

export default class FeatureThree extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            section: null
        };
    }

    async componentDidMount() {
        try {
            const res = await aboutService.getAboutContent();
            if (res.success && res.data && res.data.sections && res.data.sections.mission_vision) {
                this.setState({ section: res.data.sections.mission_vision });
            }
        } catch (err) {
            console.error('Failed to load mission and vision:', err);
        }

        const $ = window.$;
        if ($ && $(".slider-bg-slide").length) {
            $(".slider-bg-slide").each(function () {
                var Self = $(this);
                var bgSlideOptions = Self.data("options");
                Self.vegas(bgSlideOptions);
            });
        }
    }

    render() {
        const { section } = this.state;
        if(!section)return null;
        const missionText = section && section.description
            ? section.description
            : '';
        const visionText = section && section.subDescription
            ? section.subDescription
            : '';

        return (
            <>
                {/* Start Mission Vision One */}
                <section className="mission-vision-one">
                    <div className="mission-vision-one__wrapper">
                        <div className="slider-bg-slide"
                            data-options='{ "delay": 10000, "slides": [ { "src":"assets/images/update1.0/mission-vision-slide-1.jpg" }, { "src": "assets/images/update1.0/mission-vision-slide-2.jpg" }, { "src": "assets/images/update1.0/mission-vision-slide-3.jpg" } ], "transition": "slideLeft", "animation": "kenburns", "timer": false, "align": "top" }'>
                        </div>
                        <div className="slider-bg-slide-overly"></div>
                        <div className="container">
                            <div className="mission-vision-one__inner">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                        <div className="mission-vision-one__single">
                                            <div className="icon-box">
                                                <span className="icon-crane" style={{ color: "black" }}></span>
                                            </div>
                                            <h2 className='text-dark'>Our Mission</h2>
                                            <p>{missionText}</p>
                                        </div>
                                    </div>

                                    <div className="col-xl-6 col-lg-6 col-md-6">
                                        <div className="mission-vision-one__single">
                                            <div className="icon-box">
                                                <span className="icon-painting"></span>
                                            </div>
                                            <h2 className='text-dark'>Our Vision</h2>
                                            <p>{visionText}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* End Mission Vision One */}
            </>
        );
    }
}